import { Outlet } from "react-router-dom";

import ChatButton from "../ChatButton/ChatButton";

// Layout persistente por idioma: React Router lo mantiene montado mientras
// se navega entre las páginas hijas (renderizadas en el <Outlet/>).
// El botón del chatbot vive acá y no en cada página porque necesita un nodo
// DOM estable para que el script de Cloudbeds mantenga su binding por id.
const AppLayout: React.FC = () => (
    <>
        <Outlet/>
        <ChatButton/>
    </>
);

export default AppLayout;
